import { UAParser } from "@ua-parser-js/pro-business";
import { currentIdentity } from "./identity";

export const isIOS = (): boolean => {
    const parser = new UAParser();
    return parser.getOS().is("iOS");
};

export const isIosButNotMobileSafari = (): boolean => {
    const parser = new UAParser();
    return parser.getOS().is("iOS") && !parser.getBrowser().is("Mobile Safari");
};

export const isAppDiscoverable = (): boolean => {
    const { user } = currentIdentity();
    return (
        (user?.type === "client" || user?.type === "coach") &&
        !window.isMobileApp &&
        isIOS()
    );
};
